import React from "react";

const CARDS = [
  ["generated", "Generated"], ["sold", "Sold / accepted"], ["pending", "Pending"], ["bad", "Bad leads"], ["rejected", "Rejected"],
];
const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

export const ResultsTotals = ({ totals, showPrices, active, onPick }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6" data-testid="results-totals">
    {CARDS.map(([key, label]) => {
      const pickable = key !== "generated";
      const on = active === key;
      return (
        <button type="button" key={key} disabled={!pickable} onClick={() => onPick(on ? "" : key)}
                data-testid={`results-total-${key}`}
                className={`brut-card p-4 text-left transition-colors duration-100 ${on ? "bg-black text-white" : "bg-white"} ${pickable ? "hover:bg-zinc-100 hover:text-black" : "cursor-default"}`}>
          <div className="label-mono">{label}</div>
          <div className="font-chivo font-black text-3xl tracking-tighter mt-1" data-testid={`results-total-${key}-value`}>{totals?.[key] ?? 0}</div>
          {key === "pending" && totals?.in_marketplace > 0 && (
            <div className="text-[10px] mt-1 opacity-70">{totals.in_marketplace} in marketplace</div>
          )}
        </button>
      );
    })}
    {showPrices && (
      <div className="brut-card p-4 bg-zinc-900 text-white" data-testid="results-total-revenue">
        <div className="label-mono text-zinc-300">Sold for</div>
        <div className="font-chivo font-black text-3xl tracking-tighter mt-1">{money(totals?.revenue)}</div>
      </div>
    )}
  </div>
);
